/* eslint-disable @typescript-eslint/no-unused-vars */
import type { DefaultRootState } from "react-redux";
import type { ModuleInstance } from "ee/constants/ModuleInstanceConstants";

export const getModuleInstanceById = (
  state: DefaultRootState,
  id: string,
): ModuleInstance | undefined => undefined;
